<template>
  <div>
    <md-dialog
      :md-active.sync="internalShow"
      :md-click-outside-to-close="false"
      :md-close-on-esc="false"
      md-scrollable
    >
      <md-dialog-content>
        <group-card icon="add" title="Add New Custom Income Trigger" padded>
          <div class="md-layout-item">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label>Referrer</label>
                  <md-input 
                    v-model="newReferrers.query"
                    placeholder="Enter Referrer email"
                  ></md-input>
                </md-field>
                <v-data-table
                  v-if="newReferrers.results && newReferrers.query"
                  :items="newReferrers.results"
                  :headers="headers"
                  hide-default-header
                  item-key="id"
                  @click:row="handleClick"
                  hide-default-footer
                  class="elevation-1"
                ></v-data-table>
              </div>
              <div class="md-layout-item md-size-25">
                <validated-autocomplete-input
                  label="Source"
                  prefixLabel="Loan"
                  v-model="newTriggerSource"
                  :options="['SQL', 'MQL']"
                  force
                />
              </div>
              <div class="md-layout-item md-size-25">
                <span>
                  <md-tooltip md-direction="top">
                    <span v-if="!isAddTriggerDisabled">Add new constom income trigger configuration</span>
                  </md-tooltip>
                  <md-button
                    @click="addCustomIncomeTrigger"
                    class="md-primary md-layout-item"
                    :disabled="isAddTriggerDisabled"
                  >
                    Add
                  </md-button>
                  <span style="color: red" v-if="isAddTriggerDisabled">Need at least one of options, Referrer or Source</span>
                </span>
              </div>
            </div>
          </div>
        </group-card>
        <group-card icon="settings" title="Custom Income Triggers" padded>
          <template slot="actions">
            <div class="notice-bar">
              <p>Trigger order is important, start from the lowest amount range.</p>
            </div>
          </template>
          <div v-for="configs in triggerConfigs">
            <md-subheader class="sub-header">
              <span class="bold-text" v-if="configs['referrer_name'] !== 'Self Generated'">
                Referrer:&nbsp;
              </span>
              {{ configs['referrer_name'] }}&nbsp;
              <span class="bold-text">Source:&nbsp;</span>
              {{ configs['source'] }}
            </md-subheader>
            <div class="md-layout-item" v-for="trigger, index in configs['triggers']">
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>Trigger</label>
                    <md-input disabled v-model="trigger['name']"></md-input>
                  </md-field>
                </div>
                <validated-number-input
                  class="md-layout-item"
                  label="Amount"
                  v-model="trigger['amount']"
                  :prefix="'$'"
                  :min-value="0"
                  :errormsg="'Amount is required and not less than 0'"
                  required
                />
                <validated-number-input
                  class="md-layout-item"
                  label="Rate"
                  v-model="trigger['rate']"
                  :suffix="'%'"
                  :min-value="1"
                  :max-value="100"
                  :errormsg="'The rate must be less than or equal to 100.'"
                  required
                />
                <div class="md-layout-item">
                  <md-button
                      class="md-danger"
                      :disabled="index !== configs['triggers'].length - 1"
                      @click="removeTrigger(configs['triggers'], trigger)"
                    >
                      Remove Trigger
                    </md-button>
                </div>
              </div>
            </div>
            <div class="md-layout-item">
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-button
                    class="md-primary add-trigger-btn"
                    @click="addTrigger(configs['triggers'])"
                    :disabled="isAddButtonDisabled(configs['triggers'])"
                  >
                    Add Trigger
                  </md-button>
                  <span style="color: red" v-if="isAddButtonDisabled(configs['triggers'])">Maximum 10 triggers</span>
                </div>
              </div>
            </div>
          </div>
        </group-card>
      </md-dialog-content>
      <md-divider></md-divider>
      <md-dialog-actions>
        <md-button class="md-danger" @click="closeDialog">Close</md-button>
        <md-button class="md-primary" @click="saveConfigs">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import WaitingDialog from '../WaitingDialog.vue';
import AlertDialog from '../AlertDialog.vue';
import ValidatedAutocompleteInput from "@/components/ValidatedInput/ValidatedAutocompleteInput.vue";
import ValidatedNumberInput from "@/components/ValidatedInput/ValidatedNumberInput";
import GroupCard from "@/components/Cards/GroupCard.vue";

export default {
  components: {
    WaitingDialog,
    AlertDialog,
    ValidatedAutocompleteInput,
    ValidatedNumberInput,
    GroupCard,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    incomeTriggerableId: {
      type: Number,
      default: null,
    },
    incomeTriggerableType: { // in parent income-triggerable-type
      type: String,
      default: "",
    }
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Email', value: 'email'},
      ],
      internalShow: this.show,
      triggerConfigs: [],
      isSearching: false,
      newReferrers: {
        query: "",
        results: [],
        selected: {},
      },
      newTriggerSource: null,
      triggerCount: 0,
    }
  },
  watch: {
    show (newShow) {
      this.internalShow = newShow;
    },
    internalShow (newShow) {
      this.$emit('update:show', newShow);
      if (newShow == false) {
        this.$emit('close-dialog');
      }
    },
    incomeTriggerableId (newValue) {
      if (newValue) {
        this.getConfigs();
      }
    },
    'newReferrers.query' () {
      this.getReferrers();
      if (this.newReferrers.query !== this.newReferrers.selected.name) {
        this.newReferrers.selected = {};
      }
    }
  },
  computed: {
    isAddTriggerDisabled() {
      const referrerUserId = this.newReferrers.selected.id ?? null;
      const isSourceEmpty = this.newTriggerSource === null || this.newTriggerSource === "";
      return referrerUserId === null && isSourceEmpty;
    }
  },
  methods: {
    async getConfigs () {
      if (this.incomeTriggerableId === null || this.incomeTriggerableType.length == 0) {
        return;
      }
      const payload = {
        "income_triggerable_id": this.incomeTriggerableId,
        "income_triggerable_type": this.incomeTriggerableType
      }
      try {
        const response = await this.$store.dispatch('get_income_triggers', payload);
        this.triggerConfigs = response;
        this.triggerCount = this.triggerConfigs.length;
      } catch (error) {
        console.log(error);
      }
    },
    async saveConfigs () {
      if (this.incomeTriggerableId === null || this.incomeTriggerableType.length == 0) {
        this.$modal.show(AlertDialog, {
          'title': 'Successful',
          'message': 'Saving Custom Income Triggers successfully.'
        });
        return;
      }
      const validationResult = this.validateConfigs(this.triggerConfigs);
      if (!validationResult['valid']) {
        this.$modal.show(AlertDialog, {
          'title': 'Invalid',
          'message': validationResult['message'],
        });
        return;
      }
      const payload = {
        "income_triggerable_id": this.incomeTriggerableId,
        "income_triggerable_type": this.incomeTriggerableType,
        "configs": this.triggerConfigs,
      }
      this.$modal.show(WaitingDialog, {
        'title': 'Saving...',
        'message': 'Please wait while we are saving...',
      });
      try {
        const response = await this.$store.dispatch('save_income_triggers', payload);
        this.triggerConfigs = response;
        this.triggerCount = this.triggerConfigs.length;
        this.$modal.show(AlertDialog, {
          'title': 'Successful',
          'message': 'Saving Custom Income Triggers successfully.'
        });
      } catch (error) {
        console.log(error);
        this.$modal.show(AlertDialog, {
          'title': 'Failed',
          'message': 'Failed to save custom income triggers for the user.'
        });
      }
    },
    addTrigger (configs) {
      const nextTriggerNumber = this.getNextTriggerNumber(configs);
      configs.push({
        name: `trigger_${nextTriggerNumber}`,
        amount: '',
        rate: ''
      });
    },
    removeTrigger(configs, triggerToRemove) {
      const index = configs.findIndex(trigger => trigger.name === triggerToRemove.name);
      if (index !== -1) {
        configs.splice(index, 1);
      }
    },
    getNextTriggerNumber(configs) {
      const existingNumbers = configs.map(config => {
        const match = config.name.match(/trigger_(\d+)/);
        return match ? parseInt(match[1]) : 0;
      });
      return Math.max(0, ...existingNumbers) + 1;
    },
    isAddButtonDisabled(configs) {
      return configs.some(config => config.name === 'trigger_10');
    },
    closeDialog () {
      this.internalShow = false;
      this.triggerConfigs = [];
      this.newReferrers = {
        query: "",
        results: [],
        selected: {},
      },
      this.$emit('close-trigger-dialog', this.triggerCount);
    },
    beforeAddCustomIncomeTrigger () {
      const { referrerUserId, referrerName } = this.getReferrerDetail();
      let source = this.newTriggerSource;
      if (source === null || source === "") {
        source = 'Any';
      }
      const isExisted = this.isTriggerConfigurationExist(referrerUserId, source);
      if (isExisted) {
        this.$modal.show(AlertDialog, {
          'title': 'Fail',
          'message': 'The trigger is already existed in the configurations.',
        });
        return;
      }
      return { referrerUserId, referrerName, source };
    },
    addCustomIncomeTrigger () {
      const { referrerUserId, referrerName, source } = this.beforeAddCustomIncomeTrigger();

      this.triggerConfigs.push({
        'referrer_user_id': referrerUserId,
        'referrer_name': referrerName,
        'source': source,
        'triggers': [
          {
            name: `trigger_1`,
            amount: '',
            rate: ''
          }
        ]
      });

      this.afterAddCustomIncomeTrigger();
    },
    afterAddCustomIncomeTrigger () {
      this.newReferrers = {
        query: "",
        results: [],
        selected: {},
      };
      this.newTriggerSource = null;
    },
    getReferrerDetail () {
      const referrerUserId = this.newReferrers.selected.id ?? null;
      console.log(referrerUserId);
      let referrerName = "Self Generated";
      if (referrerUserId !== null) {
        referrerName = this.newReferrers.selected.name_detail.first_name + ' ' + this.newReferrers.selected.name_detail.last_name;
      }
      return { referrerUserId, referrerName };
    },
    isTriggerConfigurationExist (referrerUserId, source) {
      const isExisted = this.triggerConfigs.findIndex(config => {
        return referrerUserId == config['referrer_user_id'] && source === config['source'];
      });
      return isExisted !== -1;
    },
    async getReferrers () {
      if (this.newReferrers.query && this.newReferrers.query.length > 2) {
        this.isSearching = true;
        let { data: users } = await axios.get(`/api/v1/administration/role_based_users/${this.newReferrers.query}/Referrer`);
        this.newReferrers.results = users;
      }
      this.isSearching = false;
    },
    handleClick(referrer) {
      this.newReferrers.query = referrer.name;
      this.newReferrers.selected = referrer;
    },
    validateConfigs(configs) {
      let validationResult = null;
      for (let index in configs) {
        validationResult = this.validateTriggers(configs[index]['triggers']);
        if (!validationResult['valid']) {
          return validationResult;
        }
      }
      return validationResult;
    },
    validateTriggers(triggers) {
      if (!Array.isArray(triggers)) {
        return { valid: false, message: "Input is not an array" };
      }

      for (let i = 0; i < triggers.length; i++) {
        const { name, amount, rate, order } = triggers[i];

        // Parse the amount and rate as floats for comparison
        const amountVal = parseFloat(amount);
        const rateVal = parseFloat(rate);

        // Common validation checks for all triggers
        if (name === "trigger_1") {
          // Rule for trigger_1: amount and rate cannot be null, NaN, undefined, or empty string
          if (
            amount == null || isNaN(amountVal) || amount === '' ||
            rate == null || isNaN(rateVal) || rate === '' || rateVal === 0
          ) {
            return { valid: false, message: `Invalid amount or rate in ${name}` };
          }
        } else {
          // Rule for other triggers: amount and rate cannot be 0, null, NaN, undefined, or empty string
          const invalidAmount = (amount == null || isNaN(amountVal) || amount === '' || amountVal === 0);
          const invalidRate = (rate == null || isNaN(rateVal) || rate === '' || rateVal === 0);

          if (invalidAmount || invalidRate) {
            return { valid: false, message: `Invalid amount or rate in ${name}` };
          }
        }

        // Check ordering conditions (trigger2 > trigger1, trigger3 > trigger2, etc.)
        if (i > 0) {
          const prevTrigger = triggers[i - 1];
          const prevAmount = parseFloat(prevTrigger.amount);
          const prevRate = parseFloat(prevTrigger.rate);

          if (amountVal <= prevAmount || rateVal <= prevRate) {
            return { valid: false, message: `Amount and rate of ${name} must be greater than the previous trigger` };
          }
        }
      }

      return { valid: true, message: "All triggers are valid" };
    },
    isRateValidate(value) {
      // Check if the value is a number, positive, less than or equal to 100, and an integer
      if (typeof value === 'number' && value > 0 && value <= 100 && Number.isInteger(value)) {
          // Convert the number to a string and check if it has less than 3 digits
          return value.toString().length < 3 || value === 100;
      }
      return false;
    },
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/md-custom/_ausloans-colors.scss";

.sub-header {
  background-color: $ausloans-blue-light !important;
  border-radius: 5px;
  color: white;

  .bold-text {
    font-size: inherit;
    font-weight: bold;
  }
}

.notice-bar {
  font-weight: bold;
  color: red;
}
</style>